/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import ActingAsMerchantBanner from './ActingAsMerchantBanner';
import EmptyMerchants from './EmptyMerchants';
import Footer from './Footer';
import InlineMerchantSelector from './InlineMerchantSelector';
import MerchantInitializer from './MerchantInitializer';
import MerchantSelector from './MerchantSelector';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

export {
  ActingAsMerchantBanner,
  AvatarDropdown,
  AvatarName,
  EmptyMerchants,
  Footer,
  InlineMerchantSelector,
  MerchantInitializer,
  MerchantSelector,
  Question,
  SelectLang,
};
